import { STATUSPAGE } from '@repo/ui';
import { GetAllOrganizationsUserParams } from 'domain/models';
import {
  GetAllCoursesUserUseCaseInterface,
  GetAllGroupsUserUseCaseInterface,
  GetAllOrganizationsUserUseCaseInterface,
  PushNotificationUseCaseInterface,
} from 'domain/usecases';
import { notifyError, notifySuccess } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import {
  loadCoursesUser,
  setLoadingCoursesUser,
} from 'presentation/config/store/courses/courses-slice';
import { loadGroupsUser } from 'presentation/config/store/groups/groups-slice';
import { setLoadingGroup } from 'presentation/config/store/load-filter/loadingSlice';
import { loadOrganizationsUser } from 'presentation/config/store/organizations/organizations-slice';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

interface IProps {
  getAllGroupsUser?: GetAllGroupsUserUseCaseInterface;
  getAllCoursesUser?: GetAllCoursesUserUseCaseInterface;
  getAllOrganizationsUser?: GetAllOrganizationsUserUseCaseInterface;
}

export const usePushNotification = ({
  getAllGroupsUser,
  getAllCoursesUser,
  getAllOrganizationsUser,
}: IProps) => {
  const [loading, setLoading] = useState<STATUSPAGE>();

  const dispatch = useDispatch();
  const { pushNotificationService } = useService();

  const requestGetAllGroupsUser = useCallback(
    (params: GetAllGroupsUserUseCaseInterface.Params) => {
      dispatch(setLoadingGroup(true));

      getAllGroupsUser
        .execute(params)
        .then((res) => dispatch(loadGroupsUser(res)))
        .catch((err) => console.log(err))
        .catch(() => {})
        .finally(() => {
          dispatch(setLoadingGroup(false));
        });
    },
    [],
  );

  const requestGetAllCoursesUser = useCallback((entityId?: string) => {
    dispatch(setLoadingCoursesUser(true));

    getAllCoursesUser
      .execute({ entityId })
      .then((res) => dispatch(loadCoursesUser(res)))
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        dispatch(setLoadingCoursesUser(false));
      });
  }, []);

  const requestGetAllOrganizationsUser = useCallback(
    (params?: GetAllOrganizationsUserParams) => {
      getAllOrganizationsUser
        .execute({ course: params?.course })
        .then((res) => dispatch(loadOrganizationsUser(res)))
        .catch((err) => console.log(err));
    },
    [],
  );

  const requestPushNotification = useCallback(
    (params: PushNotificationUseCaseInterface.Params) => {
      setLoading(STATUSPAGE.LOADING);
      pushNotificationService
        .pushNotification(params)
        .then((res) => {
          notifySuccess(res.message || 'Notificação enviada com sucesso');
        })
        .catch((err) => {
          notifyError(err.message || 'Erro ao enviar notificação');
        })
        .finally(() => {
          setLoading(STATUSPAGE.DONE);
        });
    },
    [],
  );

  return {
    loading,
    requestPushNotification,
    requestGetAllGroupsUser,
    requestGetAllCoursesUser,
    requestGetAllOrganizationsUser,
  };
};
